{
  "_provenance": {
    "ns": "emails",
    "source": "family-facing emails sent by the backend (backend/src/services/applicationEmails.js), read through the generated backend/src/data/i18n/emails.json artifact — plain-text email paragraphs, never rendered by the frontend (#2125)"
  },
  "accountSetup": {
    "closing": "We’re with you.",
    "expired": "If the link has expired, choose “Forgot password?” on the sign-in page and we’ll send a fresh one.",
    "expiry": "This link expires in one hour and can be used only once.",
    "lede": "A TRF case manager has set up your family’s {{platform}} account. Set up your account to sign in: {{url}}",
    "subject": "Welcome to TRF Imagine — set up your account"
  },
  "common": {
    "greeting": "Hi {{firstName}},",
    "greetingNoName": "Hi there,",
    "machineTranslated": "This email was translated by machine. TRF has not reviewed the translation yet."
  },
  "declined": {
    "lede": "Thank you for applying to TRF. After review, we’re not able to approve your application at this time.",
    "questions": "If you have questions, please reply to this email.",
    "subject": "An update on your {{platform}} application"
  },
  "declinedRenewal": {
    "lede": "Thank you for renewing with TRF. After review, we’re not able to approve your renewal at this time.",
    "next": "A TRF team member will contact you to talk about what comes next. If you have questions before then, please reply to this email.",
    "subject": "An update on your {{platform}} renewal"
  },
  "documentRequest": {
    "attribution": "From your TRF case manager:",
    "lede": "We’re reviewing your application and still need:",
    "reassurance": "Nothing else needs redoing — sign in and add what’s listed above. Everything else you sent is saved.",
    "subject": "What TRF still needs to finish your application"
  },
  "followUp": {
    "cta": "Please sign in and update the highlighted sections: {{url}}",
    "lede": "A TRF case manager needs a little more information before we can finish reviewing your application.",
    "subject": "A quick follow-up on your {{platform}} application",
    "teamNote": "Note from the team: {{note}}"
  },
  "followUpRenewal": {
    "lede": "A TRF case manager needs a little more information before we can finish reviewing your renewal.",
    "subject": "A quick follow-up on your {{platform}} renewal"
  },
  "grantApproved": {
    "grantsPage": "You can see it any time on your Grants page: {{url}}",
    "lede": "Good news: TRF approved your family’s grant.",
    "ledeRenewal": "Good news: TRF approved your family’s renewal grant.",
    "planMonthly": "Your grant is {{monthly}} a month for {{months}} months, starting {{start}}.",
    "planMonthlyUneven": "Your grant is {{amount}}, paid monthly over {{months}} months, starting {{start}}.",
    "planOneMonth": "Your grant is {{amount}}, paid in {{start}}.",
    "questions": "If you have questions, reply to this email.",
    "subject": "Your TRF grant is approved",
    "subjectRenewal": "Your TRF renewal grant is approved"
  },
  "importInvitation": {
    "closing": "We’re with you.",
    "expiry": "This link works for {{days}} days. After that, choose “Forgot password?” on the sign-in page and we’ll send you a fresh one.",
    "lede": "TRF has set up an account for your family on {{platform}}. When you’re ready, use this link to sign in and choose your own password: {{url}}",
    "subject": "You’re invited to sign in to {{platform}}"
  },
  "magicLink": {
    "expiry": "This link expires in 15 minutes and can be used only once.",
    "lede": "Use this link to sign in to your {{platform}} account. No password needed: {{url}}",
    "notYou": "If you didn’t ask for this link, you can ignore this email.",
    "subject": "Sign in to {{brand}}"
  },
  "offer": {
    "acceptanceDue": "Please return the acceptance form by {{deadline}}.",
    "closing": "We’re with you.",
    "contacts": "Your TRF contacts are Azalea and Melanie Cooper. Reply to this email to reach them.",
    "firstPayment": "Your first Signature payment is planned for {{month}}.",
    "lede": "Your family has been welcomed into TRF. Your {{platform}} account is ready — sign in to get started: {{url}}",
    "onboarding": "The letter also gives the date of the onboarding meeting, which every new family attends.",
    "onboardingMeeting": "The onboarding meeting is on {{meeting}}.",
    "packet": "Your award letter and acceptance form will arrive separately by DocuSign. Please sign and return them by the deadline in the letter.",
    "subject": "Welcome to the Tyler Robinson Foundation"
  },
  "offerRenewal": {
    "lede": "TRF approved your family’s renewal, and your {{platform}} account is ready — sign in any time: {{url}}",
    "subject": "Welcome back to the Tyler Robinson Foundation"
  },
  "passwordReset": {
    "expiry": "This link expires in one hour and can be used only once.",
    "lede": "Someone asked to reset the password for your {{platform}} account. If that was you, set a new password here: {{url}}",
    "notYou": "If you didn’t ask for this, you can ignore this email. Your password stays the same.",
    "subject": "Reset your {{brand}} password"
  },
  "providerDocument": {
    "lede": "A medical provider has sent TRF a diagnosis letter for your application, using a secure link a TRF case manager gave them. It is now with your application and there is nothing you need to do.",
    "notExpecting": "If you were not expecting this, please reply to this email and we will look into it.",
    "subject": "A provider sent a document to {{platform}}"
  },
  "submitted": {
    "decisionTiming": "Our Family Selection Committee reviews every application; you will hear from us by email with a decision.",
    "lede": "Thank you for applying to the Tyler Robinson Foundation. Your application is in.",
    "nothingToDo": "You don’t need to do anything else right now.",
    "signIn": "You can check on your application any time by signing in at {{loginUrl}}.",
    "subject": "We received your {{platform}} application"
  },
  "submittedRenewal": {
    "decisionTiming": "Our Family Selection Committee reviews every renewal; you will hear from us by email with a decision.",
    "lede": "Thank you for renewing with the Tyler Robinson Foundation. Your renewal is in.",
    "signIn": "You can check on your renewal any time by signing in at {{loginUrl}}.",
    "subject": "We received your {{platform}} renewal"
  },
  "verifyEmail": {
    "expiry": "The link works for 24 hours. If it runs out, that’s fine: your application keeps going either way.",
    "lede": "You can keep going with your {{platform}} application right away — nothing is waiting on this email. If you’d like, confirm we have the right address: {{url}}",
    "subject": "Is this the right email for {{brand}}?"
  },
  "waitlisted": {
    "closing": "We’ll be in touch as capacity opens.",
    "lede": "Thank you for applying to TRF. Your application has been placed on our waitlist.",
    "subject": "An update on your {{platform}} application"
  },
  "waitlistedRenewal": {
    "currentGrant": "This decision is about your renewal only. It does not change any support TRF has already committed to your family.",
    "lede": "Thank you for renewing with TRF. After review, your renewal has been placed on our waitlist.",
    "next": "TRF will review your renewal again as funding opens, and we’ll email you when there is a decision.",
    "questions": "A TRF team member can answer any questions. You can also reply to this email.",
    "reviewAgain": "The committee plans to review your renewal again on {{date}}. We’ll email you when there is a decision.",
    "subject": "An update on your {{platform}} renewal"
  }
}
